import { render, staticRenderFns } from "./messageServiceSelecter.vue?vue&type=template&id=3cc9a155&scoped=true&"
import script from "./messageServiceSelecter.vue?vue&type=script&lang=js&"
export * from "./messageServiceSelecter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc9a155",
  null
  
)

export default component.exports